module.exports = __webpack_public_path__ + "static/media/hermes.94a0f70a.svg";